import React from 'react';
import { Link } from 'react-router-dom';
import {
  AiOutlineMail,
  AiOutlinePhone,
  AiOutlineEnvironment,
  AiOutlineShopping,
  AiOutlineSolution,
  AiOutlineInfoCircle,
} from 'react-icons/ai';

const Footer = () => {
  return (
    <footer className="bg-[#03045e] text-white mt-16">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <h4 className="text-xl font-semibold mb-5 text-sky-200">
              About SABEAN
            </h4>

            <p className="text-gray-300 leading-relaxed text-sm">
              Ethiopia&apos;s manufacturer of high-quality multi jet water
              meters, committed to accurate measurement, sustainable water
              management, and local manufacturing excellence.
            </p>

            <div className="mt-6 bg-white/10 rounded-2xl p-4 border border-white/10">
              <p className="text-sm text-gray-200">
                We Value Every Droplet of Water!
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-5 text-sky-200">
              Quick Links
            </h4>

            <ul className="space-y-3 text-gray-300">
              <li>
                <Link
                  to="/"
                  className="hover:text-white transition flex items-center gap-2"
                >
                  <AiOutlineInfoCircle /> Home
                </Link>
              </li>

              <li>
                <Link
                  to="/about-us"
                  className="hover:text-white transition flex items-center gap-2"
                >
                  <AiOutlineInfoCircle /> About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/services"
                  className="hover:text-white transition flex items-center gap-2"
                >
                  <AiOutlineSolution /> Services
                </Link>
              </li>

              <li>
                <Link
                  to="/contact-us"
                  className="hover:text-white transition flex items-center gap-2"
                >
                  <AiOutlineMail /> Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xl font-semibold mb-5 text-sky-200">
              Products
            </h4>

            <ul className="space-y-3 text-gray-300">
              <li>
                <Link
                  to="/products/water-meters"
                  className="hover:text-white transition flex items-center gap-2"
                >
                  <AiOutlineShopping />  Water Meters
                </Link>
              </li>

              <li>
                <Link
                  to="/products/gate-valve"
                  className="hover:text-white transition flex items-center gap-2"
                >
                  <AiOutlineShopping /> Gate Valve
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-semibold mb-5 text-sky-200">
              Contact Information
            </h4>

            <ul className="space-y-4 text-gray-300 text-sm">
              <li className="flex gap-3">
                <AiOutlinePhone className="text-xl text-sky-300 shrink-0 mt-0.5" />
                <span>+251 94 414 0354</span>
              </li>

              <li className="flex gap-3">
                <AiOutlineMail className="text-xl text-sky-300 shrink-0 mt-0.5" />
                <a
                  href="mailto:info@sabeanwatermeter.com"
                  className="hover:text-white transition"
                >
                  info@sabeanwatermeter.com
                </a>
              </li>

              <li className="flex gap-3">
                <AiOutlineEnvironment className="text-xl text-sky-300 shrink-0 mt-0.5" />
                <span>Kera, Kirkos Subcity, Addis Ababa, Ethiopia</span>
              </li>
            </ul>

            <Link to="/contact-us">
              <button className="mt-6 bg-[#0077b6] hover:bg-sky-600 text-white px-5 py-3 rounded-xl transition shadow-lg w-full md:w-auto">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-300">
          <p className="text-center md:text-left">
            Copyright &copy; {new Date().getFullYear()} SABEAN&reg; PLC. All
            Rights Reserved.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" className="hover:text-white transition">
              Home
            </Link>
            <Link to="/about-us" className="hover:text-white transition">
              About
            </Link>
            <Link to="/services" className="hover:text-white transition">
              Services
            </Link>
            <Link to="/contact-us" className="hover:text-white transition">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;